import { RENDER_CALL_CENTER } from '~constants/environment';
import LocalStorageService from '~services/LocalStorageService';

let identifiedEmail = null;

const normalizeEmail = email => (typeof email === 'string' ? email.trim().toLowerCase() : '');

const queueWonderPushCommand = command => {
  try {
    window.WonderPush = window.WonderPush || [];
    window.WonderPush.push(command);
    return true;
  } catch {
    return false;
  }
};

export const identifyPushUser = email => {
  const normalizedEmail = normalizeEmail(email);

  if (RENDER_CALL_CENTER || !normalizedEmail || normalizedEmail === identifiedEmail) {
    return;
  }

  LocalStorageService.setPushIdentified(true);
  identifiedEmail = queueWonderPushCommand(['setUserId', normalizedEmail]) ? normalizedEmail : null;
};

export const unidentifyPushUser = () => {
  if (RENDER_CALL_CENTER || (!identifiedEmail && !LocalStorageService.getPushIdentified())) {
    return;
  }

  identifiedEmail = null;
  queueWonderPushCommand([
    'unsetUserId',
    error => {
      if (!error && !identifiedEmail) {
        LocalStorageService.removePushIdentified();
      }
    }
  ]);
};
